/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import moment from "moment";
import React, { useEffect, useState } from "react";
require("moment/locale/vi");
const RenderTime = () => {
  const [currentTime, setCurrentTime] = useState(moment().toDate());
  useEffect(() => {
    const timerInterval = setInterval(() => {
      setCurrentTime(moment().toDate());
    }, 1000);

    return () => clearInterval(timerInterval);
  }, []);
  return (
    <div
      className="item-date"
      css={css`
        background-color: #2b2b2b;
        border-radius: 30px;
        width: 154px;
        line-height: 30px;
      `}
    >
      <span
        className="date"
        css={css`
          display: block;
          text-align: center;
          width: 100%;
        `}
      >
        {moment(currentTime)
          .locale("en")
          .format("YYYY/MM/DD [(]dd[)] HH:mm:ss")}
      </span>
    </div>
  );
};

export default RenderTime;
